(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover)').matches;

  // preloader
  const pre = document.getElementById('pre');
  const start = () => { pre.classList.add('out'); document.documentElement.classList.add('loaded'); };
  const img = new Image(); img.src = (getComputedStyle(document.querySelector('.hero')).getPropertyValue('--hero-img').match(/url\(["']?(.*?)["']?\)/) || [])[1] || '';
  Promise.race([img.decode().catch(() => {}), new Promise(r => setTimeout(r, 2000))]).then(() => setTimeout(start, reduce ? 0 : 600));

  // menu
  const dr = document.getElementById('drawer'), mb = document.getElementById('menuBtn');
  const setMenu = (o, back) => {
    if (o === dr.classList.contains('open')) return;
    dr.classList.toggle('open', o); dr.setAttribute('aria-hidden', !o); mb.setAttribute('aria-expanded', o); document.body.style.overflow = o ? 'hidden' : '';
    if (o) requestAnimationFrame(() => document.getElementById('menuX').focus()); else if (back) mb.focus();
  };
  mb.addEventListener('click', () => setMenu(true));
  document.getElementById('menuX').addEventListener('click', () => setMenu(false, true));
  addEventListener('keydown', e => e.key === 'Escape' && setMenu(false, true));
  dr.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setMenu(false)));

  // ---------- search ----------
  // Uses Shopify's predictive search (/search/suggest.json).
  const STORE = '';
  const sEl = document.getElementById('search'), sIn = document.getElementById('sInput'), sOut = document.getElementById('sResults'), pIn = document.getElementById('pInput');
  const POPULAR = ['Alexseal 501', 'Gelcoat', 'Garmin', 'Raymarine Axiom', 'Furuno', 'Anodes', 'Peel ply', 'Bilge pump'];
  const COLLECTIONS = [['Alexseal Coatings','/collections/alexseal'],['Electronics','/collections/marine-navigation-instruments'],['Fiberglass & Composites','/collections/composites'],['Engine & Mechanical','/collections/engine-mechanical'],['Hardware','/collections/marine-hardware'],['Safety','/collections/marine-safety'],['Electrical','/collections/electrical'],['Lighting','/collections/lighting'],['Anchoring & Docking','/collections/anchoring-docking'],['Plumbing & Pumps','/collections/marine-plumbing-ventilation'],['Clearance','/collections/clearance']];
  const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const hl = (t, q) => { let h = esc(t); q.split(/\s+/).filter(w => w.length > 1).forEach(w => { h = h.replace(new RegExp('(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>'); }); return h; };
  const money = p => '$' + Number(p).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  let seq = 0, active = -1, lastFocus = null;

  const live = async q => {
    const u = `${STORE}/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last`;
    const j = await (await fetch(u)).json(), res = j.resources.results;
    return { products: res.products.map(p => ({ t: p.title, u: p.url.split('?')[0], v: p.vendor, p: p.price, i: p.image })), collections: (res.collections || []).map(c => [c.title, c.url.split('?')[0]]) };
  };

  const renderIdle = () => {
    active = -1;
    sOut.innerHTML = `<div class="s-sec"><span class="label">Popular</span><div class="chips">${POPULAR.map(p => `<button type="button" data-q="${esc(p)}">${esc(p)}</button>`).join('')}</div></div>
      <div class="s-sec"><span class="label">Browse</span><div class="chips">${COLLECTIONS.map(([t, u]) => `<a href="${STORE}${u}">${esc(t)}</a>`).join('')}</div></div>`;
  };
  const run = async () => {
    const q = sIn.value.trim(), my = ++seq;
    if (!q) return renderIdle();
    let r;
    try { r = await live(q); }
    catch { r = { products: [], collections: [] }; }
    if (my !== seq) return;
    active = -1;
    const all = `${STORE}/search?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last`;
    sOut.innerHTML = (r.collections.length ? `<div class="s-sec"><span class="label">Collections</span><div class="chips">${r.collections.map(([t, u]) => `<a href="${STORE}${u}">${esc(t)}</a>`).join('')}</div></div>` : '') +
      `<div class="s-sec"><span class="label">Products</span>` +
      (r.products.length
        ? `<div class="s-grid">${r.products.map(p => `<a class="s-item" href="${STORE}${p.u}"><span class="s-img">${p.i ? `<img src="${esc(p.i)}" alt="" loading="lazy">` : ''}</span><span><span class="s-v">${esc(p.v || '')}</span><span class="s-t">${hl(p.t, q)}</span></span><span class="s-p">${money(p.p)}</span></a>`).join('')}</div>`
        : `<p class="s-empty">Nothing matched “${esc(q)}”. Try a part number or brand, or <a class="u" href="${STORE}/pages/contact">ask us to source it</a>.</p>`) +
      `<a class="label u s-all" href="${all}" style="color:var(--bone)">See all results for “${esc(q)}” →</a></div>`;
  };
  let t;
  let lastQ = null;
  const queue = () => { if (sIn.value === lastQ) return; lastQ = sIn.value; clearTimeout(t); t = setTimeout(run, 140); };
  sIn.addEventListener('input', queue);
  sIn.addEventListener('keyup', e => { if (!/Arrow|Enter|Escape/.test(e.key)) queue(); });
  sOut.addEventListener('click', e => { const b = e.target.closest('[data-q]'); if (b) { sIn.value = b.dataset.q; run(); sIn.focus(); } });
  document.getElementById('sForm').addEventListener('submit', e => { e.preventDefault(); const q = sIn.value.trim(); if (q) location.href = `${STORE}/search?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last`; });

  const openSearch = (q = '') => {
    lastFocus = document.activeElement; setMenu(false);
    sEl.classList.add('open'); sEl.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    sIn.value = q; lastQ = q; run(); requestAnimationFrame(() => { sIn.focus(); sIn.setSelectionRange(q.length, q.length); });
  };
  const closeSearch = () => {
    if (!sEl.classList.contains('open')) return;
    sEl.classList.remove('open'); sEl.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
    pIn.value = ''; lastFocus && lastFocus.focus && lastFocus !== pIn && lastFocus.focus();
  };
  document.querySelectorAll('[data-search]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openSearch(); }));
  document.getElementById('searchX').addEventListener('click', closeSearch);

  // keep Tab inside the open menu or search overlay
  const trapIn = (box, e) => {
    const f = [...box.querySelectorAll("a[href], button, input:not([type=hidden]), select, textarea")].filter(el => getComputedStyle(el).visibility !== "hidden" && el.getClientRects().length);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (!box.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };
  addEventListener("keydown", e => { if (e.key !== "Tab") return; if (sEl.classList.contains("open")) trapIn(sEl, e); else if (dr.classList.contains("open")) trapIn(dr, e); });
  pIn.addEventListener('input', () => openSearch(pIn.value));
  pIn.addEventListener('focus', () => { if (fine) openSearch(pIn.value); });
  addEventListener('keydown', e => {
    if (e.key === 'Escape') return closeSearch();
    if (e.key === '/' && !sEl.classList.contains('open') && !/input|textarea/i.test(document.activeElement.tagName)) { e.preventDefault(); openSearch(); }
    if (!sEl.classList.contains('open') || !/ArrowDown|ArrowUp/.test(e.key)) return;
    const items = [...sOut.querySelectorAll('.s-item')]; if (!items.length) return;
    e.preventDefault(); active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
    items.forEach((el, i) => el.classList.toggle('act', i === active)); items[active].scrollIntoView({ block: 'nearest' });
  });
  sIn.addEventListener('keydown', e => { if (e.key === 'Enter' && active > -1) { e.preventDefault(); sOut.querySelectorAll('.s-item')[active].click(); } });

  // ---------- cart ----------
  // Shopify cart API; if the AJAX call fails, fall back to the plain /cart/add link.
  const setCount = n => document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = n; });
  fetch(`${STORE}/cart.js`).then(r => r.json()).then(c => setCount(c.item_count)).catch(() => {});
  document.querySelectorAll('.pc-add[data-variant]').forEach(b => b.addEventListener('click', async () => {
    const id = b.dataset.variant;
    b.disabled = true; b.textContent = 'Adding…';
    try {
      const r = await fetch(`${STORE}/cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) });
      if (!r.ok) throw 0;
      const c = await (await fetch(`${STORE}/cart.js`)).json(); setCount(c.item_count);
      b.textContent = 'Added ✓'; b.classList.add('done');
      setTimeout(() => { b.textContent = 'Add to cart'; b.classList.remove('done'); b.disabled = false; }, 2200);
    } catch { location.href = `/cart/add?id=${id}&quantity=1`; }
  }));

  // reveals
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: .15 });
  document.querySelectorAll('.rv,.rv-img').forEach(el => io.observe(el));

  // reel: plays only while on screen
  const reel = document.getElementById('reel');
  if (reel) {
    reel.loop = true;
    new IntersectionObserver(([e]) => { if (e.isIntersecting) { reel.preload = 'auto'; reel.play().catch(() => {}); } else reel.pause(); }, { threshold: .25 }).observe(reel.parentElement);
  }

  // scroll-driven effects: computed only when the page actually scrolls
  const hdr = document.querySelector('header'), heroImg = document.getElementById('heroImg');
  const m = document.getElementById('manifesto');
  m.innerHTML = m.textContent.trim().split(/\s+/).map(w => `<span class="w">${w}</span>`).join(' ');
  const words = [...m.querySelectorAll('.w')];
  let lastY = scrollY, lit = -1, queued = false;

  const update = () => {
    queued = false;
    const y = scrollY, vh = innerHeight, past = y > vh * .8;
    hdr.classList.toggle('solid', past);
    if (Math.abs(y - lastY) > 6) { hdr.classList.toggle('hide', past && y > lastY && !dr.classList.contains('open')); lastY = y; }
    if (reduce) return;
    if (y < vh) heroImg.style.translate = `0 ${y * .22}px`;
    const r = m.getBoundingClientRect();
    if (r.bottom > 0 && r.top < vh) {
      const p = Math.min(Math.max((vh * .85 - r.top) / (r.height + vh * .3), 0), 1);
      const n = Math.round(p * words.length);
      if (n !== lit) { words.forEach((w, i) => w.classList.toggle('on', i < n)); lit = n; }
    }
  };
  addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(update); } }, { passive: true });
  update();
  if (reduce) words.forEach(w => w.classList.add('on'));

  // custom cursor (desktop only); animates only while the mouse moves
  if (fine && !reduce) {
    const c = document.getElementById('cursor');
    let x = 0, y = 0, cx = 0, cy = 0, running = false;
    const loop = () => {
      cx += (x - cx) * .35; cy += (y - cy) * .35;
      c.style.transform = `translate3d(${cx}px,${cy}px,0)`;
      running = Math.abs(x - cx) + Math.abs(y - cy) > .5;
      if (running) requestAnimationFrame(loop);
    };
    addEventListener('mousemove', e => { x = e.clientX; y = e.clientY; c.style.opacity = 1; if (!running) { running = true; requestAnimationFrame(loop); } }, { passive: true });
    document.querySelectorAll('a,button').forEach(el => { el.addEventListener('mouseenter', () => c.classList.add('big')); el.addEventListener('mouseleave', () => c.classList.remove('big')); });
  }
})();
